import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'fgb-portal-product-failure-page',
  templateUrl: './portal-product-failure-page.component.html',
  styleUrls: ['./portal-product-failure-page.component.scss'],
})
export class PortalProductFailurePageComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
